import { ErrorHandler } from '@angular/core';

export class AppErrorHandler implements ErrorHandler {

    handleError(error) {
        console.log('Global Error', error);
        // this.toastr.danger('Unexpected Errors found.', 'Oops');
    }
}
